import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5000/api";

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

export const activitiesAPI = {
  getAll: (filters) => {
    return api.get("/activities", { params: filters });
  },
  getById: (id) => api.get(`/activities/${id}`),
  getPdfUrl: (id) => `${API_BASE_URL}/activities/${id}/pdf`,
  getTravelPlan: (id, params) =>
    api.get(`/activities/${id}/travel`, { params }),
  importOpeningHours: (id) =>
    api.post(`/activities/${id}/opening-hours/import`),
  importOpeningHoursFromWebsite: (name, address, website) =>
    api.post("/activities/opening-hours/import-from-website", {
      name,
      address,
      website,
    }),
  updateOpeningHours: (id, data) =>
    api.put(`/activities/${id}/opening-hours`, data),
  create: (data) => {
    // Wenn data ein FormData-Objekt ist, setze den richtigen Content-Type
    const config =
      data instanceof FormData
        ? {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        : {};
    return api.post("/activities", data, config);
  },
  update: (id, data) => {
    const config =
      data instanceof FormData
        ? {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        : {};
    return api.put(`/activities/${id}`, data, config);
  },
  delete: (id) => api.delete(`/activities/${id}`),
  archive: (id) => api.put(`/activities/${id}`, { status: "archived" }),
};

export const authAPI = {
  login: (credentials) => api.post("/auth/login", credentials),
  register: (userData) => api.post("/auth/register", userData),
  logout: () => api.post("/auth/logout"),
  getCurrentUser: () => api.get("/auth/me"),
  verifyEmail: (token) => api.get(`/auth/verify-email?token=${token}`),
  resendVerification: (email) =>
    api.post("/auth/resend-verification", { email }),
  forgotPassword: (email) => api.post("/auth/forgot-password", { email }),
  resetPassword: (token, new_password) =>
    api.post("/auth/reset-password", { token, new_password }),
};

export const usersAPI = {
  getById: (id) => api.get(`/users/${id}`),
  update: (id, data) => api.put(`/users/${id}`, data),
  updateSettings: (data) => api.put("/users/me/settings", data),
  changePassword: (data) => api.put("/users/me/password", data),
  deleteAccount: (data) => api.delete("/users/me", { data }),
  getAll: () => api.get("/users"),
  updateRole: (id, data) => api.put(`/users/${id}/role`, data),
  delete: (id) => api.delete(`/users/${id}`),
  geocode: (address) => api.get("/users/geocode", { params: { address } }),
};

export const moderationAPI = {
  getPending: () => api.get("/moderation/activities/pending"),
  getAll: (filters) => api.get("/moderation/activities", { params: filters }),
  approve: (id) => api.post(`/moderation/activities/${id}/approve`),
  reject: (id, reason) =>
    api.post(`/moderation/activities/${id}/reject`, { reason }),
};

export default api;
